import {UseFormReturnType} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Divider, Modal, ModalProps} from "@mantine/core";
import {useCallback} from "react";
import {TagCategoryFormProvider, useTagCategoryForm} from "./useTagCategoryForm";
import {TagCategoryFormFields} from "./TagCategoryFormFields";

export interface TagCategoryFormProps {
  options?: TagCategoryFormOptions;
  defaultValues?: Partial<TagCategoryFormValues>;
  onSubmit?: (values: TagCategoryFormValues) => void;
  submitting?: boolean;
}

export interface TagCategoryFormOptions {

}

export interface TagCategoryFormValues {
  label: string
  description?: string
  doNotUse?: boolean
}

export interface TagCategoryFormDefaultValues extends Partial<TagCategoryFormValues> {

}

export interface TagCategoryFormRawValues {
  label?: string
  description?: string
  doNotUse?: boolean
}

export type TagCategoryFormType = UseFormReturnType<TagCategoryFormRawValues, (values: TagCategoryFormRawValues) => TagCategoryFormRawValues>

export const TagCategoryForm = (props: TagCategoryFormProps) => {
  const {
    options,
    defaultValues,
    onSubmit,
    submitting = false
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useTagCategoryForm({
    defaultValues: defaultValues,
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      onSubmit({
        label: values.label,
        description: values.description,
        doNotUse: values.doNotUse,
      });
    }
  }, [form, onSubmit]);

  return (
    <TagCategoryFormProvider form={form}>
      <form onSubmit={form.onSubmit(onFormSubmit)}>
        <TagCategoryFormFields options={options}/>
        <Divider my="sm" variant="dotted"/>
        <Button type="submit" loading={submitting} fullWidth mt="xl">
          {t("common.action.submit", {ns: "common"})}
        </Button>
      </form>
    </TagCategoryFormProvider>
  );
};

interface TagCategoryFormModalProps extends TagCategoryFormProps, Omit<ModalProps, 'onSubmit'> {

}

export const TagCategoryFormModal = (props: TagCategoryFormModalProps) => {
  const {
    defaultValues,
    onSubmit,
    submitting,
    ...rest
  } = props;

  return (
    <Modal {...rest}>
      <TagCategoryForm
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        submitting={submitting}/>
    </Modal>
  );
};

